import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import fastclick from 'fastclick'
import vueLazyLoad from 'vue-lazyload'
import '@/assets/sass/index.scss'
// import wx from 'weixin-js-sdk';
//import './utils/flexible'
import "@/utils/flexible";
import "@/assets/iconfont/iconfont.js"
import "@/assets/iconfont/iconfont.css";

import { utilsMixin } from '@/common/js/mixin.js';
import vaeExtended from '@/common/js/vae_extended'

import loading from '@/base/loading'
// import VuePhotoSwipe from '@/base/PhotoSwipe'
import VuePhotoPreview from '@/base/VuePhotoPreview'
import WechatTitle from '@/base/wechatTitle'
import SkeletonScreen from '@/base/SkeletonScreen/index'

import vMessage from '@/components/Message/index'
import VideoPlay from '@/components/VideoPlay/index'
import DownloadAppPop from '@/components/DownloadAppPop/index'
import Share from '@/components/share/index'
import Modal from '@/components/Modal/index'
import bridge from '@/utils/bridge.js'
import SignCanvas from "sign-canvas";

import goAppLink from '@/utils/bridgeToAppLink.js';
Vue.prototype.$goAppLink = goAppLink;

import 'vant/lib/index.css';

import { Calendar } from 'vant';
import { Overlay } from 'vant';
import { Form,Field,Area,Popup,RadioGroup,Radio,Button,DatetimePicker,Picker,Checkbox, CheckboxGroup  } from 'vant';
Vue.use(Overlay);
Vue.use(DatetimePicker);
Vue.use(Calendar);
Vue.use(Form);
Vue.use(Field);
Vue.use(Area);
Vue.use(Popup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);


//import echarts from 'echarts'
Vue.use(vMessage)
Vue.use(SignCanvas);
Vue.use(loading)
Vue.use(vaeExtended)
// Vue.use(VuePhotoSwipe)
Vue.use(VuePhotoPreview)
Vue.use(VideoPlay)
Vue.use(DownloadAppPop)
Vue.use(Share)
Vue.use(SkeletonScreen)
Vue.use(Modal)
Vue.use(WechatTitle)
Vue.mixin(utilsMixin)
Vue.use(bridge);


import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

fastclick.attach(document.body)



const url = require('@/assets/images/lazy.jpg')
// const url = window.IMG_CDN ? `${window.IMG_CDN}/fitness/dist/img/default@2x.png` : require('common/images/default.png')
Vue.use(vueLazyLoad, {
    loading: url,
    error: url
})


Vue.config.productionTip = false

let env = '';
const hostNameOne = location.hostname.split('.')[0];
if(hostNameOne === 'localhost'){
  env = 'beta'
}
if(hostNameOne.indexOf('dev') > 0){
  env = 'dev'
}
if(hostNameOne.indexOf('beta') > 0){
  env = 'beta'
}
Vue.prototype.$env = env;
console.log('环境变量--> ', env)

new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')